<template>
	<div class="container">
		<div class="page-top">
			<div class="wrapper">
				<div class="title">企业数字化转型的加速器</div>
				<div class="tip">用低代码减少开发时间和成本赋能团队创新</div>
				<div class="tip">在竞争中始终保持领先</div>
			</div>
		</div>
		<div class="platform-desc">
			<div class="wrapper">
				<div class="title">欢软低代码平台</div>
				<div class="tip">携手打造专属IT方案，低风险、高性价，助力企业稳步迈向数字化未来！</div>
				<div class="item-wrapper">
					<div class="desc-item" :class="{'active':activeId == index}" v-for="(item,index) in descList" @mouseover="activeId = index">{{item.title}}</div>
				</div>
				<div class="desc-wrapper">
					<div class="content">
						<div class="desc-title">{{descList[activeId].title}}</div>
						<div class="desc" style="white-space:pre-line">{{descList[activeId].desc}}</div>
						<div class="btn">立即体验</div>
					</div>
					<div class="image">
						<el-image :src="require('@/assets/platform/desc.png')" fit="contain"></el-image>
					</div>
				</div>
			</div>
		</div>
		<div class="soft-hot">
			<div class="wrapper">
				<div class="title">软件开发服务范围</div>
				<div class="item-wrapper">
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/product.png')"></el-image>
						</div>
						<div class="item-title">产品服务</div>
						<div class="desc">设计、开发和维护，为您的产品全生命周期保驾护航</div>
						<div class="btn">立即咨询</div>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/customized.png')"></el-image>
						</div>
						<div class="item-title">定制服务</div>
						<div class="desc">根据您的具体需求为您量身打造解决方案</div>
						<div class="btn">立即咨询</div>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/technology.png')"></el-image>
						</div>
						<div class="item-title">技术服务</div>
						<div class="desc">涵盖系统优化和技术支持，确保技术环境稳定高效</div>
						<div class="btn">立即咨询</div>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/human.png')"></el-image>
						</div>
						<div class="item-title">人力服务</div>
						<div class="desc">提供专业技术人才招聘、外包服务及培训，助力您的团队成长</div>
						<div class="btn">立即咨询</div>
					</div>
				</div>
			</div>
		</div>
		<div style="margin-top: 50px;">
			<div class="wrapper">
				<div class="title">标准化产品开发流程, 用心交付每一个项目</div>
				<div class="process-wrapper">
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/1.png')"></el-image>
						</div>
						<div class="item-title">方案定制</div>
						<div class="desc">资源规范、阶段规范运维体系</div>
					</div>
					<div class="icon">
						<i class="iconfont icon-youjiantou"></i>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/2.png')"></el-image>
						</div>
						<div class="item-title">项目管理</div>
						<div class="desc">分配人员、成立项目组制定计划</div>
					</div>
					<div class="icon">
						<i class="iconfont icon-youjiantou"></i>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/3.png')"></el-image>
						</div>
						<div class="item-title">产品设计</div>
						<div class="desc">脑图构思、交互实现原型呈现</div>
					</div>
					<div class="icon">
						<i class="iconfont icon-youjiantou"></i>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/4.png')"></el-image>
						</div>
						<div class="item-title">UI设计</div>
						<div class="desc">风格确认、功能布局界面优化</div>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/5.png')"></el-image>
						</div>
						<div class="item-title">后期维护</div>
						<div class="desc">Bug维护、迭代建议运维体系</div>
					</div>
					<div class="icon">
						<i class="iconfont icon-zuojiantou"></i>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/6.png')"></el-image>
						</div>
						<div class="item-title">上线发布</div>
						<div class="desc">最终调试、资料指导上线工作</div>
					</div>
					<div class="icon">
						<i class="iconfont icon-zuojiantou"></i>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/7.png')"></el-image>
						</div>
						<div class="item-title">全面测试</div>
						<div class="desc">功能测试、性能测试验收测试</div>
					</div>
					<div class="icon">
						<i class="iconfont icon-zuojiantou"></i>
					</div>
					<div class="item">
						<div class="image">
							<el-image :src="require('@/assets/platform/8.png')"></el-image>
						</div>
						<div class="item-title">技术开发</div>
						<div class="desc">前端开发、后台管理架构搭建</div>
					</div>
				</div>
			</div>
		</div>
		<div class="anli">
			<div class="wrapper">
				<div class="title">信息化客户案例</div>
				<div class="anli-wrapper">
					<div class="anli-item" v-for="(item,index) in anliList" :style="{'display':index>=4 ? 'none':'inline-block'}">
						<el-image class="cover-image" :src="item.cover" fit="fill"></el-image>
						<div class="title">{{item.title}}</div>
						<div class="abstrc" style="-webkit-box-orient: vertical;">{{item.summary}}</div>
						<div class="bottom">
							<div class="tag">{{ industryType[item.industryId] }}</div>
							<div class="link" @click="toDetail(item.id)">查看详情
								<div class="icon-bg">
									<i class="el-icon-right"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="btn">
					<el-button type="text" @click="$router.push({path:'/case'})">了解更多客户案例</el-button>
				</div>
			</div>
		</div>
		<div class="service">
			<div class="wrapper">
				<div class="title">更多相关服务</div>
				<div class="item-wrapper">
					<div class="item">
						<div class="item-title">标准产品：帮你实现</div>
						<div class="content">全面信息展示：详细介绍软件产品及评价，帮助客户充分了解。<br/>
						对比功能：支持多款软件对比，助力明智决策。<br/>
						透明价格：展示市场报价，确保价格信息透明。<br/>
						售后保障：提供可靠售后服务，确保无忧使用。<br/>
						透明项目管理：提供项目管理工具，实时跟踪进度，保持沟通顺畅。<br/>
						质量保障：通过评价体系和服务保障，确保高质量交付。
						</div>
						<div class="button" @click="$router.push('/store')">前往了解</div>
					</div>
					<div class="item">
						<div class="item-title">众包平台：帮你实现</div>
						<div class="content">灵活用工：按需雇佣专业人员，快速获取技术支持, 省时省力<br/>
						降低成本：按项目支付，减少全职员工和固定支出<br/>
						提高效率：利用平台工具，高效管理和完成项目<br/>
						拓展业务：通过平台合作，扩大业务和市场竞争力<br/>
						风险控制：通过合同和评价系统，降低项目风险<br/>
						质量保障：确保按时高质量交付，保障项目进度, 专业负责
						</div>
						<div class="button" @click="$router.push('/crowd')">前往了解</div>
					</div>
				</div>
			</div>
		</div>
		<div class="zixun">
			<div class="wrapper">
				<div class="title">热门资讯</div>
				<div class="zixun-msg" style="background-color: #FFFFFF; padding: 8px 8px 5px 30px; border-radius: 40px; display: inline-grid; grid-template-columns: auto 45%">
					<div class="topicList">
					  <div style="padding: 0px 20px 20px 0px;" data-aos="zoom-in-right" data-aos-delay="300">
						<div v-for="item in list" class="topicItem" @mouseover="handleHover(item)" @click="toTopicDetail(item.id)"
							 :style="currentTopicId === item.id ? { background: 'rgba(255, 132, 68, 0.05)', padding: '20px', borderRadius: '20px', display:'block'  } : {}"
							 style="color: rgb(64, 64, 64); font-size: 18px; font-weight: 500; word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden; margin-top: 10px;">
						  {{ item.title }}
		
						  <div v-if="currentTopicId === item.id"
							   style="font-size: 16px; color: rgb(109, 109, 109); letter-spacing: 1px; margin-top: 5px; word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden;">
							{{ item.description }}
						  </div>
						</div>
		
						<div v-if="list && list.length > 0" class="more" style="margin-top: 20px" @click="$router.push({name:'social',params:{typeId:topicType}})">查看更多&gt;&gt;</div>
					  </div>
					</div>
					<div class="image" data-aos="flip-right" data-aos-delay="300" style="width: 100%">
					  <el-image :src="currentTopicSrc ? currentTopicSrc : require('@/assets/fengmian.jpeg')" fit="cover"></el-image>
					</div>
				</div>
			</div>
		</div>
		<Apply/>

	</div>
</template>

<script>
import { getList,getIndustry } from '@/api/anli/anli'
import { getTopicType,getTopicList } from '@/api/social/index'
import { getIsTrial, getToken } from '@/utils/auth'
import { toLogin } from '@/api/isLogin'
import Apply from "@/components/Apply.vue";
export default {
  components: {
    Apply,
  },
  data () {
    return {
      anliList:[],
	  list:[],
	  topicType: '',
	  keyword: '',
	  mobile: '',
	  industryType: {},
	  currentTopicId: '',
	  currentTopicSrc: '',
	  activeId: 0,
	  descList:[{
		title:'管理后台',
		desc: '多样架构灵活搭配，组件支持极速上线，\n多种登录方式自如切换，分级管控保障数据安全\n档案管理轻松扩展，审批权限一键复用。'
	  },{
		title:'低代码平台',
		desc: '低代码开发工具：快速开发平台\n私有容器部署，高效率与高质量\n十二大配置引擎，可视化功能配置'
	  },{
		title:'数据管理',
		desc: '多数据源灵活接入，可视化数据轻松加工，\n自动刷新数据结果，实时预览数据效果，\n图表展示清晰直观，大屏展示一览无余，\n报表展示详尽全面，API调用灵活便捷'
	  },{
		title:'协同办公',
		desc: '工具集合，提升办公效率；\n版本管理，精准掌控变更；\n组织权限，灵活配置访问；\n共享范围，自由设定开放；\n能力开放，满足多样需求。'
	  },{
		title:'执行管理',
		desc: '项目计划高效推进，任务管理清晰有序；\n个人代办随时掌握，进度协同紧密配合；\n风险管理精准防控，资料文库轻松存取；\n过程监管全程跟踪，自动提醒贴心提示'
	  }]
    }
  },
  methods: {
	handleHover(item) {
	  this.currentTopicId = item.id;
	  this.currentTopicSrc = item.descImages;
	},
	toTopicDetail(id) {
	  this.$router.push({path: '/social/detail/' + id})
	},
    async getAnliData(){
    	const res = await getList({displayPage:'快速开发平台'})
    	if (res.code === 0) {
			this.anliList = res.data.list
    	} else {
    	  this.$message.error(res.msg)
    	}
    },
	//案例分类
	async getInsturyData(){
		const res = await getIndustry()
		if (res.code === 0) {
			for (var i = 0; i < res.data[0].dataList.length; i++) {
			  this.industryType[res.data[0].dataList[i].dictValue] = res.data[0].dataList[i].dictLabel
			}
		} else {
		  this.$message.error(res.msg)
		}
	},
	// 话题分类
	async getTypeData(){
		const res = await getTopicType()
		if (res.code === 0) {
			res.data.list.forEach((item)=>{
				if(item.typeName == '热门资讯'){
					item.children.forEach((val)=>{
						if(val.typeName == '快速开发'){
							this.topicType = val.id
						}
					})
				}
			})

			this.getDatalist()
		} else {
		  this.$message.error(res.msg)
		}
	},
	async getDatalist(){
		const res = await getTopicList({page:1,limit:10,typeId:this.topicType})
		if (res.code === 0) {
			this.list = res.data.list
			if (res.data.list && res.data.list.length > 0) {
			  this.currentTopicId = res.data.list[0].id
			  this.currentTopicSrc = res.data.list[0].descImages
			}
		} else {
		  this.$message.error(res.msg)
		}
	},
	toDetail(id){
		// if(getToken()){
			this.$router.push({ name: 'anli-detail', params: { id: id }})
		/* }else{
			toLogin(this)
		} */
	},
  },
  mounted () {
	this.getAnliData()
	this.getTypeData()
	this.getInsturyData()
  }

}
</script>

<style lang="scss" scoped>
.container{
	.wrapper{
		max-width: 1400px;
		width: 80vw;
		margin: 0 auto;
		box-sizing: border-box;
	}
	.title{
		text-align: center;
		font-size: 24px;
		font-weight: 800;
		margin: 20px 0;
	}
	.page-top{
		padding: 120px 0;
		background-color: #F6F9FF;
		position: relative;
		.title{
			font-size: 28px;
		}
		.tip{
			text-align: center;
			color: #4B4B4B;
			font-size: 20px;
			font-weight: 600;
		}
	}
	.platform-desc{
		margin-top: 50px;
		.tip{
			color: #606060;
			font-size: 16px;
			text-align: center;
		}
		.item-wrapper{
			text-align: center;
			margin: 35px auto 15px;
			.desc-item{
				display: inline-block;
				border: 1px solid #6A6A6A;
				border-radius: 20px;
				color: #717171;
				padding: 3px 20px;
				margin: 0 15px;
				cursor: pointer;
				&.active{
					background-color: #FF8632;
					border: none;
					color: #fff;
				}
			}
		}
		.desc-wrapper{
			background-color: #F6F9FF;
			border-radius: 20px;
			padding: 30px 50px;
			margin-top: 30px;
			box-sizing: border-box;
			.desc-title{
				font-size: 24px;
				font-weight: 800;
				margin: 10px 0;
			}
			.desc{
				color: #787777;
				font-size: 17px;
				line-height: 30px;
				margin: 10px 0 50px;
			}
			.btn{
				border: 1px solid #FF842E;
				color: #FF842E;
				border-radius: 20px;
				width: 100px;
				text-align: center;
				margin: 20px 0 10px;
				cursor: pointer;
			}
			.content{
				width: calc(100% - 450px);
				display: inline-block;
				margin-right: 20px;
				vertical-align: top;
				margin-top: 25px;
			}
			.image{
				display: inline-block;
				.el-image{
					width: 420px;
				}
			}
		}
	}
	.soft-hot{
		background-color: #F6F9FF;
		padding: 30px 0;
		margin-top: 50px;
		.item-wrapper{
			margin-top: 30px;
			display: flex;
			.item{
				flex: 0 0 24%;
				margin-right: 1%;
				background-color: #fff;
				border-radius: 8px;
				padding: 30px;
				box-sizing: border-box;
				position: relative;
				.image{
					margin-bottom: 20px;
					.el-image{
						width: 60px;
						height: 60px;
						border-radius: 8px;
					}
				}
				.item-title{
					color: #404040;
					font-size: 20px;
					font-weight: 800;
					margin-bottom: 20px;
				}
				.desc{
					color: #787777;
					font-size: 16px;
					margin-bottom: 80px;
				}
				.btn{
					color: #FF842E;
					border: 1px solid #FF842E;
					border-radius: 20px;
					width: 100px;
					text-align: center;
					cursor: pointer;
					position: absolute;
					left: 30px;
					bottom: 50px;
				}
			}

		}
	}
	.process-wrapper{
		margin-top: 30px;
		text-align: center;
		.item{
			width: 20%;
			display: inline-block;
			margin-right: 10px;
			background-color: #fff;
			border-radius: 8px;
			padding: 30px;
			box-sizing: border-box;
			position: relative;
			text-align: center;
			.image{
				margin-bottom: 8px;
				.el-image{
					width: 80px;
					height: 60px;
					border-radius: 8px;
					box-shadow: 0 0 10px rgba(0,0,0,.05);
				}
			}
			.item-title{
				color: #404040;
				font-size: 18px;
				font-weight: 800;
			}
			.desc{
				color: #525B5A;
				font-size: 14px;
			}

		}
		.icon{
			display: inline-block;
			vertical-align: top;
			margin-top: 80px;
			.iconfont{
				color: #FF842E;
				font-size: 26px;
			}
		}
	}
	.zixun{
		max-width: 1400px;
		width: 80vw;
		box-sizing: border-box;
		padding: 30px;
		background-color: #F6F9FF;
		border-radius: 20px;
		margin: 50px auto;
		.wrapper{
			width: 100%;
		}
	}
	.anli{
		margin-top: 50px;
		padding: 30px;
		background-color: #F6F9FF;
		.anli-wrapper{
			max-width: 1400px;
			width: 80vw;
			margin: 50px 0;
			display: grid;
			//flex-wrap: wrap;
			width: calc(100% - 45px);
			grid-template-columns: repeat(4, 25%);
			gap: 15px;
		}
		.btn{
			text-align: center;
			margin-top: 50px;
			.el-button{
				color: #FF842E;
			}
		}

		.anli-item{
		  transition: transform 0.3s ease;
		  // flex: 0 0 calc(25% - 30px);
		  // width: 300px;
		  background-color: #fff;
		  display: inline-block;
		  border-radius: 10px;
		  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05), 0 6px 10px 0 rgba(0, 0, 0, 0.05);
		  // margin: 0 30px 30px 5px;
		  font-size: 14px;
		  position: relative;
		  padding-bottom: 60px;
		  &:nth-child(4n){
			margin-right: 0;
		  }
		  .cover-image{
			width: 100%;
			height: 180px;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
		  }
		  .title{
			font-size: 18px;
			font-weight: 700;
			width: 90%;
			margin: 25px auto 10px;
			text-align: left;
			letter-spacing: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		  }
		  .abstrc{
			width: 90%;
			margin: 0 auto;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			white-space: normal;
		  }
		  .bottom{
			width: 90%;
			position: absolute;
			bottom: 20px;
			left:15px;
			.tag{
				background-color: #DBF9E5;
				color: #4BA162;
				padding: 3px 12px;
				border-radius: 5px;
				font-size: 12px;
				width: fit-content;
				display: inline-block;
			}
			.link{
				display: inline-block;
				float: right;
				cursor: pointer;
				.icon-bg{
					background-color: #FF842E;
					border-radius: 50%;
					width: 18px;
					height: 18px;
					line-height: 19px;
					display: inline-block;
					vertical-align: text-bottom;
					.el-icon-right{
						color: #fff;
					}
				}
			}
		  }
		}
		.anli-item:hover {
		  transform: translateY(-20px);
		}
	}
	.zixun .zixun-msg{
		background-color: #fff;
		border-radius: 8px;
		position: relative;
		padding: 30px;
		margin: 30px;
		min-height: 230px;
		.typeList{
			margin: 10px;
			.type-item{
				display: inline-block;
				cursor: pointer;
				font-size: 16px;
				background-color: #F5F5F5;
				width: 120px;
				height: 32px;
				line-height: 32px;
				border-radius: 20px;
				text-align: center;
				margin-right: 15px;
				&.active{
					background-color: #F6F1EE;
					color: #FF8632;
				}
			}
		}
		.topicList{
			.topicItem {
			    padding: 0 20px 0 20px;
			    //transition: all .3s;
			    cursor: pointer;
			  }
			  .topicItem:hover {
			    padding: 20px;
			    background: rgba(255, 132, 68, 0.05);
			    border-radius: 20px;
			  }
			  .topicTitle {
			    white-space: nowrap;
			    overflow: hidden;
			    text-overflow: ellipsis;
			    font-size: 16px;
			    margin-top: 8px;
			    cursor: pointer;
			  }
			
			  .more {
			    margin-top: 10px;
			    font-size: 15px;
			    cursor: pointer;
			    color: #FF8632;
			    margin-left: 20px;
			  }
			}
			
			.image {
			  //position: relative;
			  //top: 90px;
			  //right: 10px;
			  //width: 280px;
			
			  .el-image {
			    width: 100%;
			    height: 375px;
			    border-radius: 30px;
			  }
			
		}
	}
	.service{
		max-width: 1400px;
		width: 80vw;
		box-sizing: border-box;
		padding: 30px 60px;
		background-color: #F6F9FF;
		border-radius: 20px;
		margin: 50px auto;
		.wrapper{
			width: fit-content;
		}
		.item-wrapper{
			margin: 50px 0;
			display: flex;
		}
		.item{
			background-color: #fff;
			border-radius: 10px;
			display: inline-block;
			padding: 20px;
			box-sizing: border-box;
			flex: 0 0 49%;
			position: relative;
			background-image: url('../../assets/image.png');
			background-position: right bottom;
			background-repeat: no-repeat;
			background-size: 150px 150px;
			&:first-child{
				margin-right: 2%;
			}
			.item-title{
				color: #404040;
				font-size: 20px;
				font-weight: 800;
				margin-bottom: 20px;
			}
			.content{
				color:#45494F;
				font-size: 16px;
				margin-bottom: 80px;
			}
			.button{
				border: 1px solid #FF842E;
				color: #FF842E;
				border-radius: 20px;
				width: 100px;
				text-align: center;
				margin: 20px 0 10px;
				cursor: pointer;
				position: absolute;
				left: 20px;
				bottom: 40px;
			}
		}
	}
	.page-bottom{
		width: 100%;
		margin: 50px 0;
		position: relative;
		.content{
			width: 50%;
			position: absolute;
			top: 70px;
			left: 50%;
			// right: 0;
			margin-left: -25%;
			text-align: center;
			.title{
				font-size: 28px;
				font-weight: bold;
				margin: 20px 0;
				text-align: center;
			}
			.process{
				color: #454851;
				font-size: 14px;
				margin-bottom: 20px;
				margin-top: 0;
			}
			.iconfont{
				color: #BEBFC0;
				margin: 0 10px;
			}
			.input-wrapper{
				position: relative;
				max-width: 450px;
				margin: auto;
				.el-input{
					/deep/.el-input__inner{
						border-radius: 20px;
						padding-left: 25px;
					}

				}
				/deep/.el-input.is-active .el-input__inner,
				/deep/.el-input__inner:focus{
					border-color: #C0C4CC;
				}
				.el-button--warning{
					background-color: #FF842E;
				}
			}
			.btn{
				position: absolute;
				bottom: 0;
				right: 0;
				border-radius: 20px;
				padding: 12px 32px;
			}

		}
	}
}
@media (min-width: 1025px) and (max-width: 1260px) {
.container{
	.page-bottom{
		.content{
			top: 50px;
			.title{
				font-size: 24px;
				margin: 20px 0;
			}

		}
	}
}
}
@media (min-width: 768px) and (max-width: 1024px) {
.container{
	.page-bottom{
		.content{
			top: 15px;
			.title{
				font-size: 24px;
				margin: 20px 0;
			}

		}
	}
}

}
@media screen and (max-width: 767px) {
.container{
	.wrapper{
	  width: calc(100vw - 20px);
	}
	.page-top{
		padding: 40px 0 50px;
		
	}
	.platform-desc{
		margin-top: 50px;
		.tip{
			padding: 0 20px;
			box-sizing: border-box;
		}
		.item-wrapper{
			text-align: center;
			margin: 20px auto 15px;
			.desc-item{
				padding: 3px 5px;
				margin: 0;
				font-size: 14px;
				margin-right: 8px;
				&:last-child{
					margin-right: 0;
				}
			}
		}
		.desc-wrapper{
			background-color: #F6F9FF;
			border-radius: 20px;
			padding: 30px;
			margin-top: 30px;
			box-sizing: border-box;
			.content{
				width: 100%;
				display: block;
				vertical-align: top;
				margin: 0;
			}
			.desc{
				white-space: normal !important;
			}
			.image{
				display: block;
				.el-image{
					width: 100%;
				}
			}
		}
	}
	.soft-hot{
		.item-wrapper{
			margin-top: 30px;
			display: block;
			.item{
				width: calc(100% - 30px);
				margin-right: 0;
				margin: 20px 15px;
				.image{
					margin-bottom: 10px;
					.el-image{
						width: 70px;
						height: 70px;
						border-radius: 8px;
					}
				}
				.item-title{
					margin-bottom: 10px;
				}
			}
	
		}
	}
	.process-wrapper{
		margin-top: 30px;
		text-align: center;
		.item{
			width: 40%;
			
			.image{
				margin-bottom: 8px;
				.el-image{
					width: 80px;
					height: 60px;
					border-radius: 8px;
					box-shadow: 0 0 10px rgba(0,0,0,.05);
				}
			}
			.item-title{
				color: #404040;
				font-size: 18px;
				font-weight: 800;
			}
			.desc{
				color: #525B5A;
				font-size: 14px;
			}
	
		}
		.icon{
			display: inline-block;
			vertical-align: top;
			margin-top: 80px;
			.iconfont{
				color: #FF842E;
				font-size: 26px;
			}
		}
	}
	.service{
		width: calc(100vw - 20px);
		margin: 50px auto;
		padding: 30px 20px;
		.item-wrapper{
			margin: 30px 0;
			display: block;
		}
		.item{
			margin-bottom: 20px;
			margin-right: 0 !important;
			display: block;
		}
	}
	.anli {
		width: 100vw;
		padding: 30px 0;
		padding-bottom: 30px;
	    .anli-wrapper {
	      margin: 30px 0;
	      display: block;
		  padding: 0 20px;
		  box-sizing: border-box;
	      width: 100%;
		  .title{
			  font-size: 24px;
		  }
	    }
	    .anli-item {
			display: block;
			width: 100%;
			margin-bottom: 20px;
		}
	}
	.zixun {
		width: calc(100vw - 20px);
		padding: 30px 10px;
		.zixun-msg {
		  	display: block !important;
			padding: 8px 8px 5px 15px !important;
			margin: 30px 0;
			.image{
				.el-image{
					height: 245px;
				}
			}
		}
		
	}
	.page-bottom{
		.content{
			top: 15px;
			.title{
				font-size: 18px;
				margin: 10px 0;
			}
			.process{
				margin-bottom: 10px;
			}
			.input-wrapper{
				position: relative;
				.el-input{
					/deep/.el-input__inner{
						font-size: 12px;
						height: 30px;
						line-height: 30px;
					}
				}
			}
			.btn{
				position: absolute;
				bottom: 0;
				right: 0;
				border-radius: 20px;
				padding: 0 32px;
				height: 30px;
				line-height: 30px;
			}
		}
	}
}

}

</style>
